import { getPeriodOptions } from 'src/constants/filterPeriods'
import { GlobalQueryParams } from 'src/interfaces/globalQueryParams.interface'

export interface GetDateRangeByQueryParamsParamsValue {
  end?: string
  start?: string
}

export const getDateRangeByQueryParams = (
  queryParams?: GlobalQueryParams
): GetDateRangeByQueryParamsParamsValue | undefined => {
  const from = queryParams?.from
  const to = queryParams?.to

  if (from || to) {
    return {
      end: to,
      start: from,
    }
  }

  const period = queryParams?.period
    ? getPeriodOptions()[queryParams.period]
    : undefined

  if (period) {
    const periodFrom = period?.start.toISOString(true)
    const periodTo = period?.end.toISOString(true)

    if (periodFrom || periodTo) {
      return {
        end: periodTo,
        start: periodFrom,
      }
    }
  }

  return undefined
}
